import {
  AssetType,
  CalculationCountry,
  DkTaxCode,
  Owner,
  Payment,
  PaymentFrequency,
  PensionCoverage,
  Policy,
} from '@dreamplan/autogenerated-clients/calculation';
import { TestProfileWithAnswers } from '@dreamplan/types';
import { sharedDefaultAnswers } from '../sharedProfileAnswers';

export const KlausGitteProfile: TestProfileWithAnswers = {
  name: 'Klause and Gitte',
  answers: [
    ...sharedDefaultAnswers,
    {
      key: 'isUserSelfEmployed',
      value: 'false',
    },
    {
      key: 'userCurrentPensionMonthlyPayment',
      value: 5400,
    },
    {
      key: 'spouseCurrentPensionMonthlyPayment',
      value: 6750,
    },
    {
      key: 'userFullName',
      value: 'Klaus',
    },
    {
      key: 'userAge',
      value: 1982,
    },
    {
      key: 'hasSpouse',
      value: 'true',
    },
    {
      key: 'spouseName',
      value: 'Gitte',
    },
    {
      key: 'spouseAge',
      value: 35,
    },
    {
      key: 'userMonthlySalary',
      value: 45000,
    },
    {
      key: 'userCurrentPensionSavings',
      value: 500000,
    },
    {
      key: 'spouseMonthlySalary',
      value: 45000,
    },
    {
      key: 'spouseCurrentPensionSavings',
      value: 400000,
    },
    {
      key: 'houseAddress',
      value: 'test adresse',
    },
    {
      key: 'houseOwnershipType',
      value: 'Own',
    },
    {
      key: 'houseValue',
      value: 3950000,
    },
    {
      key: 'houseDebt',
      value: 3100000,
    },
    {
      key: 'houseDebtInterest',
      value: 1.79,
    },
    {
      key: 'houseDebtRemainingTenure',
      value: 28,
    },
    {
      key: 'houseDebtHasRepaymentFreeYears',
      value: 'false',
    },
    {
      key: 'userMonthlySavingsAmount',
      value: 2000,
    },
    {
      key: 'userCurrentEmergencySavings',
      value: 150000,
    },
    {
      key: 'fetchPensionInformation',
      value: 'false',
    },
    {
      key: 'hasSecondHouse',
      value: 'false',
    },
    {
      key: 'userName',
      value: 'Klaus',
    },
  ],
  expectedPayload: {
    primary: {
      birthYear: 1982,
      pensionAge: 69,
      deathAge: undefined,
    },
    spouse: {
      birthYear: 1990,
      pensionAge: 69,
      deathAge: undefined,
    },
    incomes: [
      {
        id: 'primary-income',
        owner: Owner.Primary,
        payment: {
          type: 'Payment',
          paymentFrequency: PaymentFrequency.Monthly,
          amount: 45000,
        } as Payment,
      },
      {
        id: 'spouse-income',
        owner: Owner.Spouse,
        payment: {
          type: 'Payment',
          paymentFrequency: PaymentFrequency.Monthly,
          amount: 45000,
        } as Payment,
      },
    ],
    policies: [
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc8960p',
        owner: Owner.Primary,
        coverages: [
          {
            type: 'PensionCoverage',
            id: 'dd5f84da-066d-4610-8753-4d4e9fc8960p',
            owner: Owner.Primary,
            initialValue: 500000,
            taxCode: DkTaxCode.One,
            contribution: {
              type: 'PensionContribution',
              paymentFrequency: PaymentFrequency.Monthly,
              amount: 5400,
            },
            payOutType: {
              type: 'LifeAnnuity',
            },
          } as PensionCoverage,
        ],
      } as Policy,
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc896sp',
        owner: Owner.Spouse,
        coverages: [
          {
            type: 'PensionCoverage',
            id: 'dd5f84da-066d-4610-8753-4d4e9fc896sp',
            owner: Owner.Spouse,
            initialValue: 400000,
            taxCode: DkTaxCode.One,
            contribution: {
              type: 'PensionContribution',
              paymentFrequency: PaymentFrequency.Monthly,
              amount: 6750,
            },
            payOutType: {
              type: 'LifeAnnuity',
            },
          } as PensionCoverage,
        ],
      } as Policy,
    ],
    housesWithLoans: [
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc8960f',
        houseValue: 3950000,
        type: 'HouseWithLoans',
        loans: [
          {
            id: 'd9497ef5-9d8a-4c03-8308-cbee6746339c',
            remainingPrincipal: 3100000,
            type: 'AmortizedLoan',
            contributionFeeRate: 0.006999999999999999,
            interestRate: 0.0179,
            redemptionDetails: {
              // bondPrice: 0,
              redemptionFee: 5000,
            },
            remainingRepaymentFreeYears: 0,
            remainingTenure: 28,
          },
        ],
      },
    ],
    liquidAssets: [
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc8960h',
        assetType: AssetType.Stocks,
        initialValue: 150000,
        monthlyDeposit: {
          type: 'Payment',
          amount: 2000,
          paymentFrequency: PaymentFrequency.Monthly,
        },
      },
    ],
    municipalityId: undefined,
    companies: undefined,
    dreams: undefined,
    calculationCountry: CalculationCountry.Dk,
    recommendationSettings: {
      companyRecommendation: undefined,
      primaryPensionRecommendation: undefined,
      spousePensionRecommendation: undefined,
      emergencySavingRecommendation: undefined,
      loanRecommendation: {
        type: 'RestrictedLoanToValueRatioGoalSeek',
        ratio: undefined,
        establishmentDetails: {
          foundationFee: 20000,
          // bondPrice: 98,
        },
        // interestRate: 0.06,
        // contributionFeeRate: 0.02,
      },
    },
  },
  expectedResult: undefined,
};
